$('document').ready(() => {
    if (window.innerWidth <= 767) {
        $('.site-footer__nav-item-title').click((e) => {
            let targetTitle = $(e.target);
            let navItem = targetTitle.parent();
            let navList = targetTitle.siblings('.site-footer__nav-item-list');
            navItem.toggleClass('site-footer__nav-item--active');
            navList.slideToggle();
        })
    }
})
